module.exports = __webpack_public_path__ + "img/DIlo_size.576885eb.png";